export default __webpack_public_path__ + "static/media/fast-forward.a4892e2b.svg";